import { makeAutoObservable } from "mobx";

export default class AsyncManagementStore {
  constructor() {
    makeAutoObservable(this);
  }

  currentTab = 0;

  setCurrentTab = (tab) => {
    this.currentTab = tab;
  };

  resetStore = () => {
    this.patientAdvise = null;
    this.currentTab = 0;
  };
}
